<template>
    <Modal id="modalAddNewPlayer" title="Add New Player">
        <Form @onSubmit="processAdd">
            <Input name="id_player" v-model="id_player" label="ID" />
            <Input name="name" v-model="name" label="NAME" />
            <Input name="power" v-model="power" label="POWER" />
            <label class="flex items-center space-x-2 mb-2 cursor-pointer">
                <input v-model="is_fc" type="checkbox" true-value="1" false-value="0" class="w-5 h-5 text-emerald-500 border-gray-300 rounded focus:ring-emerald-500">
                <span class="text-gray-700">Crystal Furnace</span> 
            </label>
            <Input name="furnice_level" v-model="furnice_level" label="FURNICE LEVEL" />
            <Button type="submit" class="!m-0 w-full">Add</Button>
        </Form>
    </Modal>
</template>

<script>
import Modal from '@/components/noc_ui/Modal.vue'
import Form from '@/components/noc_ui/XForm.vue'
import Button from '@/components/noc_ui/Button.vue'
import Input from '@/components/noc_ui/Input.vue'

export default {
    components: {
        Modal,
        Form,
        Button,
        Input
    },
    data() {
        return {
            id_player: '',
            name: '',
            power: '',
            is_fc: false,
            furnice_level: ''
        }
    },
    methods: {
        async processAdd({ formdata }) {

            let { data, error } = await this.$supabase.from('members').insert([
                {
                    id_player: this.id_player,
                    name: this.name,
                    power: this.power,
                    is_fc: this.is_fc,
                    furnice_level: this.furnice_level
                }
            ])

            if ( error ) {
                this.$Swal.fire("", "Error", "error");
                return
            }
            this.$noc('#modalAddNewPlayer').modal('hide')
            this.$Swal.fire("", "Added successfully", "success")
            this.$parent.getPlayers()
        }
    },
    mounted() {

    }
}
</script>